import biorhythmChange from './actions/biorhythmChange';
import biorhythmCreate from './actions/biorhythmCreate';
import biorhythmDetail from './actions/biorhythmDetail';
import biorhythmsList from './actions/biorhythmsList';
import getBiorhythms from './getters/getBiorhythms';
import biorhythmsUpload from './mutations/biorhythmsUpload';

const actions = {
    biorhythmChange,
    biorhythmCreate,
    biorhythmDetail,
    biorhythmsList
};

const mutations = {
    biorhythmsUpload
};

const getters = {
    getBiorhythms
};

export default { actions, mutations, getters };
